import React from 'react';
import { Link } from 'gatsby';

const Footer = () => {
  return (
    <nav className="footer">
      <div className="container ">
        <div className="footer-content">
          <h3>
            <div className="tilt-text">Ready to</div>
            Job-search smarter?
            <br />
            We make it easy.
          </h3>
          <Link to="/" className="button">
            Get Started for Free
          </Link>
        </div>
        <div className="footer-nav">
          <div className="top-footer flex-row col">
            <Link to="/">
              <img src="/img/cliphire-logo-white.svg" alt="" />
            </Link>
            <a href="mailto:hello@cliphire.co" className="contact-us">
              Contact Us
            </a>
          </div>
          <div className="bottom-footer flex-row col">
            <div className="footer-links flex-row col">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms-of-service">Terms of Service</Link>
              <Link to="/cookie-policy">Cookie Policy</Link>
              <Link to="/acceptable-use-policy">Acceptable Use Policy</Link>
              <Link to="/blog">Blog</Link>
            </div>
            <div className="footer-logo">
              <a href="https://www.linkedin.com/company/clip-hire/" target="_blank" rel="noopener noreferrer">
                <img src="/img/linkedin-logo-footer.svg" alt="linkedin" />
              </a>
              <a href="https://www.facebook.com/cliphire" target="_blank" rel="noopener noreferrer">
                <img src="/img/facebook-logo.svg" alt="facebook" />
              </a>
              <a href="https://twitter.com/Clip_Hire" target="_blank" rel="noopener noreferrer">
                <img src="/img/twitter-logo.svg" alt="twitter" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Footer;
